var _rect, _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 256 256",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#63bce7",
    height: 137.164,
    rx: 5,
    width: 83.583,
    x: 86.208,
    y: 12.598
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m86.208 144.762a5 5 0 0 0 5 5h73.583a5 5 0 0 0 5-5v-13.333h-83.583z",
    fill: "#9e9e9e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m169.792 17.6a5 5 0 0 0 -5-5h-73.584a5 5 0 0 0 -5 5v5.5h83.583z",
    fill: "#9e9e9e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m159.792 144.762v-127.162a5 5 0 0 0 -5-5h10a5 5 0 0 1 5 5v127.162a5 5 0 0 1 -5 5h-10a5 5 0 0 0 5-5z",
    fill: "#63e2e7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m159.792 144.762v-13.333h10v13.333a5 5 0 0 1 -5 5h-10a5 5 0 0 0 5-5z",
    fill: "#cecece"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m154.792 12.6h10a5 5 0 0 1 5 5v5.5h-10v-5.5a5 5 0 0 0 -5-5z",
    fill: "#cecece"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 140.596,
    fill: "#3f3679",
    r: 4.708
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m97.747 31h60.505v33.25h-60.505z",
    fill: "#f8af23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m97.747 73.375h26.926v47.125h-26.926z",
    fill: "#f46275"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m131.326 73.375h26.926v47.125h-26.926z",
    fill: "#cecece"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m169.792 51.319v42.587l-8.382-9.834a9.77 9.77 0 0 0 -13.734-1.094 9.771 9.771 0 0 0 -1.095 13.734l19.069 22.372s-5.692 24.018 9.311 37.742h42.413l-3.76-51.6c-.451-4.765-3.389-8.8-6.377-12.13z",
    fill: "#f8af23"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m213.614 105.228c-.451-4.765-3.39-8.8-6.377-12.13l-37.445-41.779v11.158l27.444 30.623c2.988 3.333 5.926 7.365 6.377 12.13l3.76 51.6h10z",
    fill: "#f8d323"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m156.203 156.824h74.223v30.613h-74.223z",
    fill: "#cecece"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m220.425 156.824h10v30.613h-10z",
    fill: "#e2e2e2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m160.601 187.436h65.427v44.993h-65.427z",
    fill: "#63bce7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m216.027 187.436h10v44.993h-10z",
    fill: "#63e2e7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m86.208 51.319v42.587l8.382-9.834a9.77 9.77 0 0 1 13.734-1.094 9.771 9.771 0 0 1 1.095 13.734l-19.069 22.37s5.692 24.018-9.311 37.742h-42.413l3.76-51.6c.451-4.765 3.389-8.8 6.377-12.13z",
    fill: "#f8af23"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m42.386 105.228c.451-4.765 3.39-8.8 6.377-12.13l37.445-41.779v11.158l-27.444 30.623c-2.988 3.333-5.926 7.365-6.377 12.13l-3.76 51.6h-10z",
    fill: "#f87023"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m25.575 156.824h74.223v30.613h-74.223z",
    fill: "#cecece",
    transform: "matrix(-1 0 0 -1 125.372 344.26)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m25.575 156.824h10v30.613h-10z",
    fill: "#afafaf"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m29.973 187.436h65.427v44.993h-65.427z",
    fill: "#63bce7",
    transform: "matrix(-1 0 0 -1 125.372 419.866)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m29.973 187.436h10v44.993h-10z",
    fill: "#6377e7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3f3679"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m159.752 64.25v-33.25a1.5 1.5 0 0 0 -1.5-1.5h-60.5a1.5 1.5 0 0 0 -1.5 1.5v33.25a1.5 1.5 0 0 0 1.5 1.5h60.5a1.5 1.5 0 0 0 1.5-1.5zm-3-1.5h-57.5v-30.25h57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.56 170.63a1.5 1.5 0 0 0 0 3h8.814a1.5 1.5 0 0 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.626 173.63h8.814a1.5 1.5 0 0 0 0-3h-8.814a1.5 1.5 0 0 0 0 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.323 241.9h-18a1.5 1.5 0 1 0 0 3h18a1.5 1.5 0 1 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.68 241.9h-18a1.5 1.5 0 0 0 0 3h18a1.5 1.5 0 0 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.479 241.9h-180.958a1.5 1.5 0 0 0 0 3h180.958a1.5 1.5 0 0 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.18 232.429a1.5 1.5 0 0 0 -1.5-1.5h-19.153v-41.992h2.9a1.5 1.5 0 0 0 1.5-1.5v-30.613a1.5 1.5 0 0 0 -1.5-1.5h-11.658l-3.662-50.238c-.512-5.405-3.878-9.781-6.753-12.989l-37.062-41.352v-33.145a6.508 6.508 0 0 0 -6.5-6.5h-73.584a6.508 6.508 0 0 0 -6.5 6.5v33.145l-37.062 41.355c-2.875 3.2-6.246 7.581-6.756 13.018l-3.659 50.206h-11.656a1.5 1.5 0 0 0 -1.5 1.5v30.612a1.5 1.5 0 0 0 1.5 1.5h2.9v41.992h-19.155a1.5 1.5 0 1 0 0 3h237.36a1.5 1.5 0 0 0 1.5-1.499zm-19.255-46.492h-71.225v-12.307h41.306a1.5 1.5 0 0 0 0-3h-41.306v-12.306h71.223zm-129.128 3a1.5 1.5 0 0 0 1.5-1.5v-30.613a1.5 1.5 0 0 0 -1.5-1.5h-15.236a30.985 30.985 0 0 0 3.439-4.924 6.486 6.486 0 0 0 3.21.862h73.583a6.5 6.5 0 0 0 3.207-.862 31 31 0 0 0 3.435 4.92h-15.235a1.5 1.5 0 0 0 -1.5 1.5v30.612a1.5 1.5 0 0 0 1.5 1.5h2.9v41.992h-62.2v-41.987zm9.5-107.1a11.228 11.228 0 0 0 -10.05-2.329v-4.633h23.926v44.125h-23.925v-8.045l11.313-13.272a11.254 11.254 0 0 0 -1.261-15.847zm-11.549 40.163h26.926a1.5 1.5 0 0 0 1.5-1.5v-47.125a1.5 1.5 0 0 0 -1.5-1.5h-26.926a1.5 1.5 0 0 0 -1.5 1.5v7.372a11.179 11.179 0 0 0 -2.8 2.352l-5.741 6.735v-65.234h80.583v65.233l-5.739-6.733a11.169 11.169 0 0 0 -2.8-2.353v-7.372a1.5 1.5 0 0 0 -1.5-1.5h-26.924a1.5 1.5 0 0 0 -1.5 1.5v47.125a1.5 1.5 0 0 0 1.5 1.5h26.926a1.5 1.5 0 0 0 1.5-1.5v-6.025l4.278 5.019a54.847 54.847 0 0 0 -.937 10.436h-70.187a54.847 54.847 0 0 0 -.937-10.436l4.278-5.019v6.025a1.5 1.5 0 0 0 1.5 1.5zm47.692-24.316 11.313 13.272v8.044h-23.926v-44.125h23.926v4.631a11.232 11.232 0 0 0 -11.313 18.178zm-52.625 35.245h70.371a41.819 41.819 0 0 0 3.464 14.791 3.493 3.493 0 0 1 -1.858.543h-73.584a3.491 3.491 0 0 1 -1.859-.541 41.817 41.817 0 0 0 3.466-14.793zm113.3-38.83c2.569 2.866 5.572 6.736 6 11.238l3.643 49.987h-40.206c-5.642-5.381-8.793-12.954-9.37-22.522a51.623 51.623 0 0 1 .928-13.375 1.5 1.5 0 0 0 -.318-1.317l-19.069-22.372a8.242 8.242 0 0 1 12.545-10.694l8.383 9.835 15.917 18.673a1.5 1.5 0 1 0 2.283-1.945l-15.559-18.253v-38.114zm-118.407-76.499a3.5 3.5 0 0 1 3.5-3.5h73.583a3.5 3.5 0 0 1 3.5 3.5v4h-80.583zm-43.829 87.769c.43-4.534 3.433-8.4 6-11.271l34.829-38.858v38.114l-15.558 18.252a1.5 1.5 0 1 0 2.283 1.945l15.917-18.672 8.383-9.835a8.242 8.242 0 0 1 12.545 10.694l-19.07 22.371a1.5 1.5 0 0 0 -.318 1.317 51.623 51.623 0 0 1 .928 13.375c-.577 9.568-3.729 17.142-9.37 22.522h-40.209zm-16.8 52.955h71.221v12.306h-41.309a1.5 1.5 0 0 0 0 3h41.309v12.307h-71.225zm4.4 72.6v-41.987h62.421v41.992zm130.628 0v-41.987h62.427v41.992z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService02);
export default __webpack_public_path__ + "static/media/service02.3cc9c21a73cb43620da919187fd5782f.svg";
export { ForwardRef as ReactComponent };